<script>
import "@design/tailwind.css";
import "./design/styles.scss";

export default {
	components: {},
	mounted() {},
};
</script>
<template>
  <RouterView/>
</template>